/* global ol */

var moveStopLocationTemplate = require('html/templates/moveStopLocation')();
var moveStopLocationsTemplate = require('html/templates/moveStopLocations')();

function MoveStopsInteraction(map, modal) {
  this.map = map;
  this.modal = modal;

  this.stroke = new ol.style.Stroke({
    color: 'white',
    width: 2,
    lineDash: [2, 2],
    lineCap: 'butt'
  });

  this.addClickInteraction();
  this.addDragInteraction();

  this.selectedStyle = this.selectedStyle.bind(this);
  this.closeModal = this.closeModal.bind(this);

  this.map.map.on('dblclick', this.closeModal);
  this.map.view.on('change:resolution', this.closeModal);
}

MoveStopsInteraction.prototype.addClickInteraction = function() {
  this.clickInteraction = new ol.interaction.Select({
    addCondition: ol.events.condition.singleClick,
    toggleCondition: ol.events.condition.never,
    layers: this.map.layers('routeLayers'),
    style: []
  });

  this.clickInteraction.on('select', this.onSelect.bind(this));
};

MoveStopsInteraction.prototype.addDragInteraction = function() {
  this.dragInteraction = new ol.interaction.DragBox({
    condition: ol.events.condition.platformModifierKeyOnly,
    minArea: 22
  });

  this.dragInteraction.on('boxdrag', this.toggleCursor);
  this.dragInteraction.on('boxend', this.onBoxend.bind(this));
};

MoveStopsInteraction.prototype.onSelect = function(event) {
  var selectedFeatures = event.selected;
  var selectedStops = this.selectedStops(selectedFeatures);

  this.clickInteraction.getFeatures().clear(); // Makes the feature reselectable
  this.map.tooltip.hideTooltip();
  this.openMoveStopsModal(selectedStops, selectedFeatures);
};

MoveStopsInteraction.prototype.onBoxend = function() {
  var extent = this.dragInteraction.getGeometry().getExtent();
  var selectedFeatures = this.selectedFeatures(extent);
  var selectedStops = this.selectedStops(selectedFeatures);

  this.toggleCursor();

  if (selectedStops.length) {
    this.openMoveStopsModal(selectedStops, selectedFeatures);
  }
};

MoveStopsInteraction.prototype.selectedFeatures = function(extent) {
  return this.map.layers('routeLayers')
    .filter(function(layer) {
      return layer.getVisible();
    })
    .reduce(function(selected, layer) {
      return selected.concat(layer.getSource().getFeaturesInExtent(extent));
    }, []);
};

MoveStopsInteraction.prototype.selectedStops = function(selectedFeatures) {
  return selectedFeatures.reduce(function(selected, feature) {
    return selected.concat(
      feature.get('features').map(function(feature) {
        return feature.get('stop');
      })
    );
  }, []);
};

MoveStopsInteraction.prototype.openMoveStopsModal = function(stops, features) {
  var afterMove = this.afterMove.bind(this, features);

  this.closeModal();

  if (stops.length > 1) {
    this.map.scope.prepareMultiMove(stops);
    this.map.scope.multiMove.close = afterMove;
  } else {
    if (this.map.scope.move) {
      // prepareMove will call the close function if it exists
      this.map.scope.move.close = undefined;
    }
    this.map.scope.prepareMove(stops[0]);
    this.map.scope.move.map = true;
    this.map.scope.move.close = afterMove;
  }

  this.toggleStyle(features, true);

  this.modal.open({
    scope: this.map.scope,
    moveable: true,
    klass: 'map move-stop-location',
    body: stops.length > 1 ? moveStopLocationsTemplate : moveStopLocationTemplate,
    onClose: this.toggleStyle.bind(this, features)
  });
};

MoveStopsInteraction.prototype.closeModal = function() {
  this.map.scope._modal && this.map.scope._modal.close();
};

MoveStopsInteraction.prototype.afterMove = function(features) {
  this.closeModal();
  setTimeout(this.moveClusters.bind(this, features));
};

MoveStopsInteraction.prototype.moveClusters = function(features) {
  features.forEach(function(feature) {
    feature.get('features').forEach(function(feature) {
      var oldLayer = feature.get('layer');
      var newLayer = this.map.routeLayers[feature.get('stop').route.id];

      oldLayer.layer.getSource().getSource().removeFeature(feature);
      newLayer.layer.getSource().getSource().addFeature(feature);
      feature.set('layer', newLayer);
    }, this);
  }, this);
};

MoveStopsInteraction.prototype.toggleCursor = function(event) {
  document.getElementById('map').style.cursor = event ? 'move' : '';
};

MoveStopsInteraction.prototype.toggleStyle = function(features, on) {
  features.forEach(function(feature) {
    feature.setStyle(on ? this.selectedStyle : null);
  }, this);
};

MoveStopsInteraction.prototype.selectedStyle = function(feature, resolution) {
  var layer = feature.get('features')[0].get('layer');
  var style = layer.layer.getStyle()(feature, resolution);
  var circle = style.length ? style[0] : style;

  circle.setStroke(this.stroke);

  return style;
};

module.exports = MoveStopsInteraction;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/map/moveStopsInteraction.js
 ** module id = 185
 ** module chunks = 1
 **/